
export class ContactFormController {
    constructor(contactService) {
        this.states = contactService.getStateOptions();
    }
}
ContactFormController.$inject = ['janglContactService'];

export default ContactFormController;


// WEBPACK FOOTER //
// ./app/jangl/contact-fields/controller.js